import React, { useState, useEffect, useRef, useCallback } from 'react';

import { Character } from "@dndModels/character";
import FlexBox from '@components/layout/FlexBox';
import CommonUtilities from '@utilities/common_utilities';
import ModalOrDrawer from '@components/display/ModalOrDrawer';
import CharacterPBCustomizations from '../customizations/CharacterPBCustomizations';

interface Props { 
  char: Character;
}

const common_util = CommonUtilities.getInstance();

export default function CharacterProficiencyBonus({
  char,
}: Props) {
  const [pb, setPB] = useState(0);
  const [open, setOpen] = useState(false);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  const recalculated = useCallback(() => {
    setTimeout(() => {
      setPB(char.char_interface.proficiency_modifier);
    }, 100);
  }, [char]);

  useEffect(() => {
    char.subscription_holder.subscribe("Recalculated", mounted, recalculated);
    recalculated();
  }, [char, recalculated]);

  const renderExtras = () => {
    return (
      <ModalOrDrawer
        open={open}
        onClose={() => { setOpen(false) }}
      >
        <CharacterPBCustomizations char={char} />
      </ModalOrDrawer>
    );
  }

  return (
    <>
      <FlexBox direction="column" className="clickable" onClick={() => setOpen(true) }>
        <FlexBox>
          <div className="centered" style={{
            fontSize: "11px",
            fontWeight: "bold",
          }}>
            Proficiency
          </div>
        </FlexBox>
        <FlexBox>
          <div className="centered" style={{
            fontSize: "24px",
            fontWeight: "bold",
          }}>
            { common_util.addPlusMaybe(pb) }
          </div>
        </FlexBox>
        <FlexBox>
          <div className="centered" style={{
            fontSize: "11px",
            fontWeight: "bold",
          }}>
            Bonus
          </div>
        </FlexBox>
      </FlexBox>
      { renderExtras() }
    </>
  );
}
